export default (route) => {
  window.localStorage.setItem('destinationURL', route?.fullPath)
}
